import { Card, Col, Row } from "react-bootstrap";
import { formatStorageValueFromMB } from "../../shared/storageUtils";
import { useStorage } from "../../contexts/storage";


const StorageCard: React.FC = () => {
    const { storage, progress } = useStorage();
    
    return(
        <Row>
            <Col md={6} lg={4} className="mx-auto">
                {storage && progress && (
                    <Card className="text-center" style={{ backgroundColor: `${progress.percentage >= progress.percentageLimit ? "pink" : ""}` }}>
                        <Card.Body>
                            {progress.percentage >= progress.percentageLimit && <div className='my-2'>Você já consumiu {progress.percentage}%</div>}
                            <div className='progress-bar-container' style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
                                <div className='progress-bar' style={{ width: `${progress.percentage}%`, backgroundColor: '#007bff', color: '#fff' }}>
                                    {progress.percentage}%
                                </div>
                            </div>
                            <Card.Text>
                                <p className="mb-0">
                                    Armazenamento: {formatStorageValueFromMB(storage.tamanhoArmazenadoEmMB)} / {formatStorageValueFromMB(storage.tamanhoArmazenamentoContratadoEmMB)} utilizados
                                </p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                )}
            </Col>
        </Row>
    );
}

export default StorageCard;